// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_breakdown_mode_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_breakdown_mode_model.proto.
 */
export const file_bffuser_v1_demand_breakdown_mode_model: GenFile = /*@__PURE__*/
  fileDesc("CixiZmZ1c2VyL3YxL2RlbWFuZF9icmVha2Rvd25fbW9kZV9tb2RlbC5wcm90bxIKYmZmdXNlci52MSLxAgoWRGVtYW5kQnJlYWtkb3duTW9kZVJvdxIoCglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRIVCg1yZXRhaWxlcl9jb2RlGAIgASgJEhoKDXJldGFpbGVyX25hbWUYAyABKAlIAIgBARIQCghpbl9zY29wZRgEIAEoCBIxCgZzdGF0dXMYBSABKA4yIS5iZmZ1c2VyLnYxLkRlbWFuZEJyZWFrZG93blN0YXR1cxIbChNieV9ncm91cF9zZWxlY3RhYmxlGAYgASgIEhEKBG5vdGUYByABKAlIAYgBARIXCgp1cGRhdGVkX2J5GAggASgJSAKIAQESMwoKdXBkYXRlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIA4gBAUIQCg5fcmV0YWlsZXJfbmFtZUIHCgVfbm90ZUINCgtfdXBkYXRlZF9ieUINCgtfdXBkYXRlZF9hdCqCAQoTRGVtYW5kQnJlYWtkb3duTW9kZRIlCiFERU1BTkRfQlJFQUtET1dOX01PREVfVU5TUEVDSUZJRUQQABIgChxERU1BTkRfQlJFQUtET1dOX01PREVfRElSRUNUEAESIgoeREVNQU5EX0JSRUFLRE9XTl9NT0RFX0JZX0dST1VQEAIq3wEKFURlbWFuZEJyZWFrZG93blN0YXR1cxInCiNERU1BTkRfQlJFQUtET1dOX1NUQVRVU19VTlNQRUNJRklFRBAAEiMKH0RFTUFORF9CUkVBS0RPV05fU1RBVFVTX0RFRkFVTFQQARIiCh5ERU1BTkRfQlJFQUtET1dOX1NUQVRVU19ESVJFQ1QQAhIkCiBERU1BTkRfQlJFQUtET1dOX1NUQVRVU19CWV9HUk9VUBADEi4KKkRFTUFORF9CUkVBS0RPV05fU1RBVFVTX0JZX0dST1VQX05PX0dST1VQUxAEKtkBCh5EZW1hbmRCcmVha2Rvd25TYXZlRXJyb3JSZWFzb24SMgouREVNQU5EX0JSRUFLRE9XTl9TQVZFX0VSUk9SX1JFQVNPTl9VTlNQRUNJRklFRBAAEkUKQURFTUFORF9CUkVBS0RPV05fU0FWRV9FUlJPUl9SRUFTT05fQllfR1JPVVBfV0lUSE9VVF9ERU1BTkRfR1JPVVBTEAESPAo4REVNQU5EX0JSRUFLRE9XTl9TQVZFX0VSUk9SX1JFQVNPTl9SRVRBSUxFUl9PVVRfT0ZfU0NPUEUQAkJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_google_protobuf_timestamp]);

/**
 * DemandBreakdownModeRow is one row of the 想定モード list: a retailer of the
 * area's demand-forecast scope today, or a retailer outside it that still
 * has a setting.
 *
 * @generated from message bffuser.v1.DemandBreakdownModeRow
 */
export type DemandBreakdownModeRow = Message<"bffuser.v1.DemandBreakdownModeRow"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string retailer_code = 2;
   */
  retailerCode: string;

  /**
   * In-scope rows carry the scope's display name; out-of-scope rows the
   * business master's name for the code (regardless of its valid period).
   * Unset when neither has one.
   *
   * @generated from field: optional string retailer_name = 3;
   */
  retailerName?: string;

  /**
   * False for a retailer outside today's scope whose setting remains; such a
   * row can only be deleted.
   *
   * @generated from field: bool in_scope = 4;
   */
  inScope: boolean;

  /**
   * @generated from field: bffuser.v1.DemandBreakdownStatus status = 5;
   */
  status: DemandBreakdownStatus;

  /**
   * Whether グループ別 can be saved for this row (the same rule the save
   * rejection uses).
   *
   * @generated from field: bool by_group_selectable = 6;
   */
  byGroupSelectable: boolean;

  /**
   * @generated from field: optional string note = 7;
   */
  note?: string;

  /**
   * eauth member ID of the last updater. Unset when there is no setting.
   *
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;

  /**
   * Optimistic-lock token and last-updated time of the setting. Unset when
   * there is no setting.
   *
   * @generated from field: optional google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DemandBreakdownModeRow.
 * Use `create(DemandBreakdownModeRowSchema)` to create a new message.
 */
export const DemandBreakdownModeRowSchema: GenMessage<DemandBreakdownModeRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_breakdown_mode_model, 0);

/**
 * DemandBreakdownMode is the 想定モード a retailer is set to in an area
 * (docs/domain/models/demand-breakdown-mode.md).
 *
 * @generated from enum bffuser.v1.DemandBreakdownMode
 */
export enum DemandBreakdownMode {
  /**
   * @generated from enum value: DEMAND_BREAKDOWN_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 一括想定: the retailer's demand is forecast as one.
   *
   * @generated from enum value: DEMAND_BREAKDOWN_MODE_DIRECT = 1;
   */
  DIRECT = 1,

  /**
   * グループ別: forecast per 需要グループ and summed.
   *
   * @generated from enum value: DEMAND_BREAKDOWN_MODE_BY_GROUP = 2;
   */
  BY_GROUP = 2,
}

/**
 * Describes the enum bffuser.v1.DemandBreakdownMode.
 */
export const DemandBreakdownModeSchema: GenEnum<DemandBreakdownMode> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_breakdown_mode_model, 0);

/**
 * DemandBreakdownStatus is the resolved state of one (area, retailer) pair
 * today: the setting together with whether it is actually in effect.
 *
 * @generated from enum bffuser.v1.DemandBreakdownStatus
 */
export enum DemandBreakdownStatus {
  /**
   * @generated from enum value: DEMAND_BREAKDOWN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No setting covers today; the 一括想定 default applies.
   *
   * @generated from enum value: DEMAND_BREAKDOWN_STATUS_DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * Set to 一括想定.
   *
   * @generated from enum value: DEMAND_BREAKDOWN_STATUS_DIRECT = 2;
   */
  DIRECT = 2,

  /**
   * Set to グループ別 and the retailer has a 需要グループ in the area.
   *
   * @generated from enum value: DEMAND_BREAKDOWN_STATUS_BY_GROUP = 3;
   */
  BY_GROUP = 3,

  /**
   * Set to グループ別 but the retailer has no 需要グループ in the area, so
   * 一括想定 is used instead (shown as「グループ未作成」).
   *
   * @generated from enum value: DEMAND_BREAKDOWN_STATUS_BY_GROUP_NO_GROUPS = 4;
   */
  BY_GROUP_NO_GROUPS = 4,
}

/**
 * Describes the enum bffuser.v1.DemandBreakdownStatus.
 */
export const DemandBreakdownStatusSchema: GenEnum<DemandBreakdownStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_breakdown_mode_model, 1);

/**
 * DemandBreakdownSaveErrorReason classifies why SaveDemandBreakdownMode was
 * rejected with FAILED_PRECONDITION (google.rpc.ErrorInfo.reason).
 *
 * @generated from enum bffuser.v1.DemandBreakdownSaveErrorReason
 */
export enum DemandBreakdownSaveErrorReason {
  /**
   * @generated from enum value: DEMAND_BREAKDOWN_SAVE_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * グループ別 was requested but the retailer has no 需要グループ in the area.
   *
   * @generated from enum value: DEMAND_BREAKDOWN_SAVE_ERROR_REASON_BY_GROUP_WITHOUT_DEMAND_GROUPS = 1;
   */
  BY_GROUP_WITHOUT_DEMAND_GROUPS = 1,

  /**
   * The retailer is not among the area's demand-forecast retailers today.
   *
   * @generated from enum value: DEMAND_BREAKDOWN_SAVE_ERROR_REASON_RETAILER_OUT_OF_SCOPE = 2;
   */
  RETAILER_OUT_OF_SCOPE = 2,
}

/**
 * Describes the enum bffuser.v1.DemandBreakdownSaveErrorReason.
 */
export const DemandBreakdownSaveErrorReasonSchema: GenEnum<DemandBreakdownSaveErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_breakdown_mode_model, 2);

